import React from "react";
import './stakeholders.css'
import {Advantages, Benenfits } from "../components";
import "./../App.css";
const Stakeholders = () => {
  return (
    <div>

        <Advantages />
        <div className="page">
        <Benenfits />
      </div>
    </div>
  );
};

export default Stakeholders;
